import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownBanner() {
  const TOTAL_SECONDS = 15 * 60; // 15 minutes
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const isUrgent = secondsLeft < 5 * 60;
  return <section className="bg-burgundy-800 text-cream-50 py-1 px-2 relative overflow-hidden" data-id="element-16">
      {/* Subtle animated background shimmer */}
      <div className="absolute inset-0 bg-gradient-to-r from-burgundy-800 via-burgundy-700 to-burgundy-800 opacity-50" data-id="element-17"></div>

      <div className="max-w-4xl mx-auto relative z-10 flex flex-row items-center justify-center gap-2 text-center" data-id="element-18">
        <p className="text-xs font-medium text-dusty-rose-200" data-id="element-19">
          ⏳ Esta oferta expira en:
        </p>

        <div className="flex items-center gap-1.5" data-id="element-20">
          {/* Minutes */}
          <motion.div key={`m-${minutes}`} initial={{
          scale: 1.15,
          opacity: 0.7
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.3
        }} className={`flex items-center justify-center w-7 h-7 rounded font-heading font-bold text-sm ${isUrgent ? 'bg-dusty-rose-500 text-white' : 'bg-gold-300 text-burgundy-900'} shadow-sm`} data-id="element-21">
            {pad(minutes)}
          </motion.div>

          <span className={`text-sm font-bold ${isUrgent ? 'text-dusty-rose-300' : 'text-gold-300'}`} data-id="element-22">
            :
          </span>

          {/* Seconds */}
          <motion.div key={`s-${seconds}`} initial={{
          scale: 1.15,
          opacity: 0.7
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.3
        }} className={`flex items-center justify-center w-7 h-7 rounded font-heading font-bold text-sm ${isUrgent ? 'bg-dusty-rose-500 text-white' : 'bg-gold-300 text-burgundy-900'} shadow-sm`} data-id="element-23">
            {pad(seconds)}
          </motion.div>
        </div>

        {secondsLeft === 0 && <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-sm font-bold text-dusty-rose-300" data-id="element-24">
            ¡La oferta ha expirado!
          </motion.p>}
      </div>
    </section>;
}